import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PlusIcon from '../../assets/icons/Pluse.svg';
import { Box, Grid2, IconButton, Typography } from "@mui/material";
import { Label } from "flowbite-react";
import { useState } from "react";

const EditableDropdown = ({ label, options, setOptions, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [newOption, setNewOption] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [openAddButton, setOpenAddButton] = useState(false);

  const handleOpenSaveButton = () => {
    setOpenAddButton(true);
  }

  const handleAdd = () => {
    if (newOption.trim()) {
      setOptions(prev => {
        const updated = [...prev, newOption.trim()];
        onUpdate && onUpdate(updated);
        return updated;
      });
      setNewOption('');
    }
  };

  const handleDelete = (opt) => {
    setOptions(prev => {
      const updated = prev.filter(item => item !== opt);
      onUpdate && onUpdate(updated);
      return updated;
    });
  };

  const handleEdit = (index, currentValue) => {
    setEditIndex(index);
    setEditValue(currentValue);
  };

  const handleSave = (index) => {
    if (editValue.trim() === '') return;
    setOptions(prev => {
      const updated = [...prev];
      updated[index] = editValue.trim();
      onUpdate && onUpdate(updated);
      return updated;
    });
    setEditIndex(null);
    setEditValue('');
  };

  return (
    <Grid2 sx={{ marginTop: '1%' }}>
      <Label>{label}</Label>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
          backgroundColor: '#f9f9f9',
          padding: 1.5,
          borderRadius: 1,
          border: '1px solid #ccc',
          mt: 1
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography> {label}</Typography>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Box>

      <Collapse in={open}>
        <Box sx={{ mt: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#fff' }}>
          {options.map((opt, idx) => (
            <Box key={idx} sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
              p: 1,
              borderRadius: 1,
            }}>
              {editIndex === idx ? (
                <TextField
                  value={editValue}
                  onChange={(e) => setEditValue(e.target.value)}
                  size="small"
                  sx={{ flex: 1, mr: 1 }}
                />
              ) : (
                <Typography sx={{ flex: 1 }}>{opt}</Typography>
              )}
              <Box>
                {editIndex === idx ? (
                  <IconButton size="small" onClick={() => handleSave(idx)}>
                    <SaveIcon />
                  </IconButton>
                ) : (
                  <IconButton size="small" onClick={() => handleEdit(idx, opt)}>
                    <EditIcon />
                  </IconButton>
                )}
                <IconButton size="small" onClick={() => handleDelete(opt)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))}

          {!openAddButton && 
            <Grid2 onClick={handleOpenSaveButton} sx={{border:'1px dotted #6BA6FF', borderRadius:'8px', padding:'12px', display:'flex', alignItems:'center', justifyContent:'center'}}>
              <img src={PlusIcon} alt="addIconBooking" />
              <Typography sx={{color:'#0065ff', marginLeft:'12px'}}>Add New Option</Typography>
            </Grid2>
          }

          {openAddButton && 
            <Box sx={{ mt: 2 }}>
              <TextField
                placeholder="Enter new option"
                value={newOption}
                onChange={(e) => setNewOption(e.target.value)}
                size="medium"
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '18px',
                    backgroundColor: '#fff',
                    paddingRight: '8px',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      variant="contained"
                      onClick={handleAdd}
                      sx={{
                        borderRadius: '12px',
                        textTransform: 'none',
                        minWidth: '80px',
                        backgroundColor: '#0066FF',
                        '&:hover': {
                          backgroundColor: '#0052CC'
                        }
                      }}
                    >
                      Save
                    </Button>
                  ),
                }}
              />
            </Box>
          }
        </Box>
      </Collapse>
    </Grid2>
  );
};

export default EditableDropdown;
